import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import { company } from "../../mock";

function ContactInfoRow({ icon: Icon, label, children }) {
  return (
    <div className="flex items-start gap-4">
      <div className="w-12 h-12 rounded-xl bg-brand text-white flex items-center justify-center shrink-0">
        <Icon size={20} />
      </div>
      <div>
        <div className="text-xs uppercase tracking-widest text-gray-500">{label}</div>
        {children}
      </div>
    </div>
  );
}

export default function ContactInfo() {
  return (
    <div>
      <div className="section-label mb-4">Get In Touch</div>
      <h2 className="font-display text-3xl md:text-4xl font-bold text-gray-900 leading-tight">
        Let’s build your <span className="text-brand">winning team</span>
      </h2>
      <p className="mt-4 text-gray-600">Talk to us about recruitment, training, or BPO solutions. Our experts are ready to help.</p>

      <div className="mt-8 space-y-5">
        <ContactInfoRow icon={Mail} label="Email">
          <a href={`mailto:${company.email}`} className="text-gray-900 font-semibold hover:text-brand block">{company.email}</a>
          <a href={`mailto:${company.careerEmail}`} className="text-gray-900 font-semibold hover:text-brand block">{company.careerEmail}</a>
        </ContactInfoRow>

        <ContactInfoRow icon={Phone} label="Phone">
          <a href={`tel:${company.phone}`} className="text-gray-900 font-semibold hover:text-brand">{company.phone}</a>
        </ContactInfoRow>

        <ContactInfoRow icon={MapPin} label="Locations">
          <div className="text-gray-900 font-semibold">{company.locations}</div>
          <div className="text-sm text-gray-500 mt-0.5">{company.address}</div>
        </ContactInfoRow>
      </div>
    </div>
  );
}
